<template>
  <b-modal
      data-test-path="dialog-yes-no"
      id="bv-modal-import-or-update-product"
      @hide="onHide"
      @ok="onOk"
      ref="modal"
      title="Import or update products"
  >
    <b-container>
      <b-row class="pb-3">
        <b-col>
          <label class="m-0">{{tr('importOrUpdate.choose.want','Choose what you want to do')}}:</label>
          <b-form-select
              v-model="mainOptionSelected"
              :options="mainOptions"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row
          v-if="mainOptionSelected && mainOptionSelected !== NEW_IMPORT && mainOptionSelected !== UPDATE_DYNAMIC_ATTRIBUTES && mainOptionSelected !== UPDATE_UNITS"
          class="pb-3">
        <b-col>
          <label class="m-0">{{tr('importOrUpdate.supple/overw','Supplementing / Overwriting')}}</label>
          <b-form-select
              v-model="updateOptionSelected"
              :options="updateOptions"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="pb-3" v-if="updateOptionSelected && mainOptionSelected === UPDATE_PRODUCTS_THAT_ARE_IN_SEASON">
        <b-col>
          <label class="m-0">{{tr('seasonRange','Season range')}}</label>
          <b-form-select
              v-model="seasonRangeOptionSelected"
              :options="seasonsOptions"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="seasonRangeOptionSelected === SELECTED_SEASON">
        <b-col>
          <label class="m-0">{{tr('season','Season')}}</label>
          <b-form-select
              v-model="seasonSelectedId"
              :options="listOfSeasons"
              text-field="season"
              value-field="id"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="mainOptionSelected === UPDATE_PRODUCTS_THAT_ARE_IN_SEASON">
        <b-col>
          <b-form-checkbox
              v-model="updateProductsInSeasonData"
          >
            {{tr('importOrUpdate.update.products.in','Also update products in seasons data')}}
          </b-form-checkbox>
          <label class="mt-2 text-danger" style="font-size: 14px">
            {{tr('importOrUpdate.promotional.will.overwrite',
              'The promotional and the retail price will be overwritten on the products in the seasons.')}}
          </label>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row>
          <b-col class="text-right">
            <b-button
                style="width: 76px"
                variant="plm-secondary"
                @click="onHide"
            > {{ cancelLabel }}
            </b-button>
            <b-button
                style="width: 76px"
                data-test-path="yes-button-dialog"
                :variant="'plm-save'"
                @click="onOk"
                :disabled="!canSubmit"
            >
              {{ okLabel }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>

</template>

<script>

import * as Labels from '@/components/forms/customizations/plm/ImportProductOperationLabels';
import {LABEL_UPDATE_DYNAMIC_ATTRIBUTES} from "@/components/forms/customizations/plm/ImportProductOperationLabels";
import tr from "../../utils/Tr";


export default {
  name: "ImportOrUpdateProductDialog",
  async mounted() {
    if (SessionManager.applicationUser?.id) {
      this.listOfSeasons = await Rpc.plm.services.BudgetingPlannerService.listSeasons();
    }
  },
  methods: {
    tr,

    async onOk(ev) {
      if (this.resolve != null) {
        switch (this.mainOptionSelected) {
          case this.UPDATE_UNITS:
            this.resolve({
              operationType: Labels.LABEL_UPDATE_PRODUCT_UNITS,
              updateProductsInSeasonData: this.updateProductsInSeasonData,
              season: null,
            });
            break;
          case this.NEW_IMPORT:
            this.resolve({
              operationType: Labels.OPERATION_NEW_IMPORT,
              updateProductsInSeasonData: this.updateProductsInSeasonData,
              season: null,
            });
            break;
          case this.UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON:
            if (this.updateOptionSelected === this.OVERWRITING_DATA) {
              this.resolve({
                operationType: Labels.OPERATION_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON_OVERWRITING_DATA,
                updateProductsInSeasonData: this.updateProductsInSeasonData,
                season: null,
              });
            } else if (this.updateOptionSelected === this.SUPPLEMENTING_THE_MISSING_DATA) {
              this.resolve({
                operationType: Labels.OPERATION_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON_SUPPLEMENTING_DATA,
                updateProductsInSeasonData: this.updateProductsInSeasonData,
                season: null,
              });
            }
            break;
          case this.UPDATE_PRODUCTS_THAT_ARE_IN_SEASON:
            if (this.updateOptionSelected === this.OVERWRITING_DATA) {
              if (this.seasonRangeOptionSelected === this.SELECTED_SEASON) {
                this.resolve({
                  operationType: Labels.OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_OVERWRITING_DATA_SELECTED_SEASON,
                  updateProductsInSeasonData: this.updateProductsInSeasonData,
                  season: this.selectedSeason,
                });
              }
              if (this.seasonRangeOptionSelected === this.ALL_SEASONS) {
                this.resolve({
                  operationType: Labels.OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_OVERWRITING_DATA_ALL_SEASONS,
                  updateProductsInSeasonData: this.updateProductsInSeasonData,
                  season: null,
                });
              }
            }
            if (this.updateOptionSelected === this.SUPPLEMENTING_THE_MISSING_DATA) {
              if (this.seasonRangeOptionSelected === this.SELECTED_SEASON) {
                this.resolve({
                  operationType: Labels.OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_SUPPLEMENTING_DATA_SELECTED_SEASON,
                  updateProductsInSeasonData: this.updateProductsInSeasonData,
                  season: this.selectedSeason,
                });
              }
              if (this.seasonRangeOptionSelected === this.ALL_SEASONS) {
                this.resolve({
                  operationType: Labels.OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_SUPPLEMENTING_DATA_ALL_SEASONS,
                  updateProductsInSeasonData: this.updateProductsInSeasonData,
                  season: null,
                });
              }
            }
            break;
          case this.UPDATE_DYNAMIC_ATTRIBUTES:
            this.resolve({
              operationType: Labels.LABEL_UPDATE_DYNAMIC_ATTRIBUTES,
              updateProductsInSeasonData: this.updateProductsInSeasonData,
              season: null,
            });
            break;
        }
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(false);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async reset() {
      this.resolve = null;
      this.listOfSeasons = await Rpc.plm.services.BudgetingPlannerService.listSeasons();
      this.mainOptionSelected = null;
      this.updateOptionSelected = null;
      this.seasonRangeOptionSelected = null;
      this.seasonSelectedId = null;
      this.updateProductsInSeasonData = false;
    },
  },

  watch: {
    mainOptionSelected: function (val) {
      this.canSubmit = (val === Labels.LABEL_NEW_IMPORT || val === Labels.LABEL_UPDATE_DYNAMIC_ATTRIBUTES);
      if (val === Labels.LABEL_NEW_IMPORT) {
        this.seasonRangeOptionSelected = null;
        this.updateOptionSelected = null;
        this.seasonSelectedId = null;
        setTimeout(() => {
          this.canSubmit = true;
        });
      }
      if (val === Labels.LABEL_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON) {
        this.seasonRangeOptionSelected = null;
        this.seasonSelectedId = null;
        setTimeout(() => {
          this.canSubmit = true;
        });
      }
      if (val === Labels.LABEL_UPDATE_PRODUCT_UNITS) {
        this.seasonRangeOptionSelected = null;
        this.seasonSelectedId = null;
        setTimeout(() => {
          this.canSubmit = true;
        });
      }
    },
    seasonRangeOptionSelected: function (val) {
      this.canSubmit = val === Labels.LABEL_ALL_SEASONS;
    },

    updateOptionSelected: function (val) {
      if (val && this.mainOptionSelected === this.UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON) {
        this.canSubmit = true;
      } else {
        this.canSubmit = false;
      }

      // TODO usunąć poniższego ifa jak będzie wersjonowanie produktów gotowe, czyli włączona selected season
      if (this.seasonRangeOptionSelected) {
        this.canSubmit = true;
      }
    },

    seasonSelectedId: function (val) {
      for (let el of this.listOfSeasons) {
        if (el.id === val) {
          this.selectedSeason = el;
        }
      }
      if (val) {
        this.canSubmit = true;
      } else {
        this.canSubmit = false;
      }
    }
  },
  data: () => ({
    NEW_IMPORT: Labels.LABEL_NEW_IMPORT,
    UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON: Labels.LABEL_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON,
    UPDATE_PRODUCTS_THAT_ARE_IN_SEASON: Labels.LABEL_PRODUCTS_THAT_ARE_IN_SEASON,
    UPDATE_DYNAMIC_ATTRIBUTES: Labels.LABEL_UPDATE_DYNAMIC_ATTRIBUTES,
    SUPPLEMENTING_THE_MISSING_DATA: Labels.LABEL_SUPPLEMENTING_THE_MISSING_DATA,
    UPDATE_UNITS: Labels.LABEL_UPDATE_PRODUCT_UNITS,
    OVERWRITING_DATA: Labels.LABEL_OVERWRITING_DATA,
    ALL_SEASONS: Labels.LABEL_ALL_SEASONS,
    SELECTED_SEASON: Labels.LABEL_SELECTED_SEASON,
    resolve: null,
    cancelLabel: "Cancel",
    okLabel: "Next",
    mainOptionSelected: null,
    updateOptionSelected: null,
    seasonRangeOptionSelected: null,
    selectedSeason: null,
    seasonSelectedId: null,
    mainOptions: [Labels.LABEL_NEW_IMPORT, Labels.LABEL_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON,
      Labels.LABEL_PRODUCTS_THAT_ARE_IN_SEASON, LABEL_UPDATE_DYNAMIC_ATTRIBUTES, Labels.LABEL_UPDATE_PRODUCT_UNITS
    ],
    updateOptions: [Labels.LABEL_SUPPLEMENTING_THE_MISSING_DATA, Labels.LABEL_OVERWRITING_DATA],
    // TODO odkomentować jak będzie funkcjonalność wersjonowania produktów
    // seasonsOptions: [Labels.LABEL_ALL_SEASONS, Labels.LABEL_SELECTED_SEASON],
    seasonsOptions: [Labels.LABEL_ALL_SEASONS],
    listOfSeasons: [],
    canSubmit: false,
    updateProductsInSeasonData: false
  })
}
</script>
